import React, { useMemo } from "react";
import { isProduction } from "@helpers/isProduction.helper";
import { Helmet } from "react-helmet";
import { format } from "date-fns";
import { DynamicBlock } from "src/blocks/DynamicBlock.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import SocialMediaSharing from "src/blocks/components/SocialMediaSharing/SocialMediaSharing.component";
import { EventPageProps } from "./EventPage.interface";
import LatestEvents from "./components/LatestEvents/LatestEvents.component";
import S from "./EventPage.module.scss";

const EventPage = (props: EventPageProps) => {
    const robotsIndexFollow = useMemo(() => {
        if (!isProduction()) {
            return "noindex, nofollow";
        }

        return `${props.props.allowIndexing === true ? "index" : "noindex"},
                ${props.props.allowFollowing === true ? "follow" : "nofollow"}`;
    }, [props.props?.allowFollowing, props.props?.allowIndexing]);

    return (
        <main className={S.wrapper} id="main">
            <Helmet>
                <title>{props.props?.metaTitle || props.name}</title>
                <meta name="description" content={props.props?.metaDescription} />
                <meta name="robots" content={robotsIndexFollow} />
            </Helmet>

            {/* Hero */}
            {props?.props?.hero?.[0]
                ? props.props.hero?.map((block, index) => <DynamicBlock key={index} {...block} />)
                : null}

            <DA_Container className={S.container} noVerticalPadding>
                <main className={S.main} id="main">
                    <div className={S.toolbar}>
                        {props.props.startDate ? (
                            <strong>{format(new Date(props.props.startDate), "dd.MM.yyyy")}</strong>
                        ) : null}

                        <div className={S.tags}>
                            {props.props.tags.map((tag, index) => (
                                <div className={S.tag} key={index}>
                                    {tag}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/** Title */}
                    <DA_Title h2 tag={DA_TitleTag.H2}>
                        {props.props.title}
                    </DA_Title>

                    {/** Text */}
                    <strong className={S.introductory}>{props.props.introductory}</strong>

                    {/* Blocks */}
                    <div className={S.content}>
                        {props?.props?.modules?.[0]
                            ? props.props.modules?.map((block, index) => (
                                  <DynamicBlock key={index} {...block} compact />
                              ))
                            : null}
                    </div>
                    <SocialMediaSharing />
                </main>

                {/** Related News */}
                <aside className={S.aside}>
                    <LatestEvents take={3} currentUrl={props.url} />
                </aside>
            </DA_Container>
        </main>
    );
};

export default EventPage;
